(function () {
  if (window.location.pathname !== '/collections/oceanside-ice-hockey') return;

  const moveTimer = setInterval(() => {
    const timers = document.querySelectorAll('.timer-store-front');
    const filterForm = document.querySelector('#FacetFiltersForm');

    if (timers.length > 0 && filterForm && !document.querySelector('#single-header-timer')) {
      const container = document.createElement('div');
      container.id = 'single-header-timer';

      // Move the live node (keeps it ticking) instead of cloneNode
      container.appendChild(timers[0]);

      const sampleSpan = timers[0].querySelector('span');
if (sampleSpan) {
  container.style.setProperty('--timer-color', getComputedStyle(sampleSpan).color);
}
      const activeFacets = document.querySelector('.active-facets');
      if (activeFacets) {
        activeFacets.parentNode.insertBefore(container, activeFacets.nextSibling);
      } else {
        filterForm.prepend(container);
      }

      clearInterval(moveTimer);
    }
  }, 500);

  setTimeout(() => clearInterval(moveTimer), 30000);
})();